var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrap" },
    [
      _c(
        "div",
        { staticClass: "is-weiXin-tip hidden", class: { show: _vm.isWx } },
        [
          _c("img", {
            staticClass: "tip-open",
            attrs: {
              src: require("@/assets/case-share-detail/what_tip.png"),
              alt: ""
            }
          })
        ]
      ),
      _c("img", {
        staticClass: "banner",
        attrs: {
          src: require("@/assets/imgs/share-page/Frame1321315956@2x.png")
        }
      }),
      _vm._m(0),
      _vm.scrollLists.length > 0
        ? _c(
            "div",
            { staticClass: "swipe-box" },
            [
              _c(
                "van-notice-bar",
                { attrs: { scrollable: false } },
                [
                  _c(
                    "van-swipe",
                    {
                      staticClass: "notice-swipe",
                      attrs: {
                        vertical: "",
                        autoplay: 3000,
                        "show-indicators": false
                      }
                    },
                    _vm._l(_vm.scrollLists, function(item, i) {
                      return _c(
                        "van-swipe-item",
                        { key: i, staticClass: "flex flex-align-center" },
                        [
                          item.avatar
                            ? _c("img", {
                                staticClass: "header-icon",
                                attrs: { src: item.avatar }
                              })
                            : _vm._e(),
                          _c("span", { staticClass: "line1 block" }, [
                            _vm._v(
                              "刚刚" +
                                _vm._s(item.lawyerName) +
                                "律师通过沾沾喜气，获得" +
                                _vm._s(_vm.priceYuan(item.amount, 1)) +
                                "个法临币"
                            )
                          ])
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "content-wrap" }, [
        _c("img", {
          staticClass: "banner1",
          attrs: {
            src: require("@/assets/imgs/share-page/Frame1321314799@2x.png")
          }
        }),
        _c("h4", [_vm._v(_vm._s(_vm.detail.title))]),
        _c("div", { staticClass: "desc-date" }, [
          _vm._v(_vm._s(_vm.detail.createTime) + " "),
          _c("a", [_vm._v("#" + _vm._s(_vm.detail.typeLabel))]),
          _vm._v(" " + _vm._s(_vm.detail.totalPv) + "浏览")
        ]),
        _c("div", { staticClass: "line" }),
        _c("div", { staticClass: "con-box" }, [
          _vm._m(1),
          _c(
            "div",
            {
              staticClass:
                "box-lawyer flex-space-between flex flex-align-center"
            },
            [
              _c("div", { staticClass: "lawyer-info flex" }, [
                _c("div", { staticClass: "lawyer-img" }, [
                  _c("img", {
                    staticClass: "lawyer-info-header",
                    attrs: { src: _vm.detail.lawyerAvatar }
                  }),
                  _vm.detail.isVip
                    ? _c("img", {
                        staticClass: "lawyer-info-icon",
                        attrs: {
                          src: require("@/assets/imgs/share-page/icon-v.png")
                        }
                      })
                    : _vm._e()
                ]),
                _c("div", [
                  _c("h5", [
                    _vm._v(_vm._s(_vm.detail.lawyerName) + " "),
                    _c("i", [_vm._v(_vm._s(_vm.detail.lawyerCity))])
                  ]),
                  _c("p", { staticClass: "lawyer-info-tag font11" }, [
                    _c("i", [
                      _vm._v("擅长" + _vm._s(_vm.detail.lawyerWorkFieldList[0]))
                    ]),
                    _c("i", [_vm._v("官方认证")])
                  ])
                ])
              ]),
              _c("div", { staticClass: "box-case tc" }, [
                _c("p", [_vm._v("案源消耗数")]),
                _c("p", [
                  _c("a", [_vm._v(_vm._s(_vm.detail.serverCaseNumCount))]),
                  _vm._v(" 次")
                ])
              ])
            ]
          )
        ]),
        _c("div", { staticClass: "con-box pr" }, [
          _vm._m(2),
          _c("img", {
            staticClass: "pa icons",
            attrs: { src: require("@/assets/imgs/share-page/ca.png") }
          }),
          _c(
            "ul",
            _vm._l(_vm.lists, function(item, i) {
              return _c(
                "li",
                {
                  key: i,
                  staticClass: "flex flex-align-center flex-space-between"
                },
                [
                  _c("label", [_vm._v(_vm._s(item.label))]),
                  _c("i", [
                    _vm._v(
                      _vm._s(
                        item.type === "money"
                          ? _vm.priceYuan(_vm.detail[item.prop])
                          : _vm.detail[item.prop]
                      )
                    )
                  ])
                ]
              )
            }),
            0
          )
        ]),
        _c("div", { staticClass: "con-box" }, [
          _vm._m(3),
          _c("div", [_vm._v(_vm._s(_vm.detail.caseReview))])
        ]),
        _c("div", { staticClass: "con-box" }, [
          _vm._m(4),
          _c("div", [_vm._v(_vm._s(_vm.detail.caseDetail))])
        ]),
        _vm._m(5)
      ]),
      _c("div", { staticClass: "footers" }, [
        _c("button", { on: { click: _vm.handleOpen } }, [
          _vm._v("点击前往APP沾沾喜气，瓜分现金红包")
        ]),
        _c("p", [
          _vm._v("已有"),
          _c("i", [_vm._v(_vm._s(_vm.detail.redPacketGetNum || 0) + "人")]),
          _vm._v("沾他喜气，还剩"),
          _c("i", [_vm._v(_vm._s(_vm.detail.redPacketRemainNum) + "个")]),
          _vm._v("现金红包 ")
        ])
      ]),
      _c(
        "popupIndex",
        {
          staticClass: "popup-wrap",
          attrs: { show: _vm.dialog },
          on: {
            "update:show": function($event) {
              _vm.dialog = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "red-box",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.handleOpen.apply(null, arguments)
                }
              }
            },
            [
              _c("div", { staticClass: "header-ataver" }, [
                _c("img", { attrs: { src: _vm.detail.lawyerAvatar } }),
                _vm._v("沾沾" + _vm._s(_vm.detail.lawyerName) + "律师成单喜气 ")
              ]),
              _c("h1", [
                _vm._v("最高瓜分"),
                _c("i", [_vm._v("100")]),
                _vm._v("个法临币")
              ]),
              _c("p", [_vm._v("看看您的运气吧")]),
              _c("div", { staticClass: "red-box-text" }, [
                _vm._v("· 已有"),
                _c("i", [
                  _vm._v(_vm._s(_vm.detail.redPacketGetNum || 0) + "人")
                ]),
                _vm._v("沾他喜气，还剩"),
                _c("i", [_vm._v(_vm._s(_vm.detail.redPacketRemainNum) + "个")]),
                _vm._v("现金红包 ·")
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-box flex flex-space-between" }, [
      _c("div", { staticClass: "texts pr" }, [
        _c("p", [_vm._v("点击红包沾喜气")]),
        _c("p", [
          _vm._v("瓜分20个现金红包"),
          _c("img", {
            attrs: {
              src: require("@/assets/imgs/share-page/Frame1321315959@2x.png")
            }
          })
        ]),
        _c("img", {
          staticClass: "icon",
          attrs: { src: require("@/assets/imgs/share-page/money-bg.png") }
        })
      ]),
      _c("img", {
        staticClass: "red-bag block",
        attrs: { src: require("@/assets/imgs/share-page/Frame8670@2x.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box-tit" }, [_c("i"), _vm._v(" 成案律师")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box-tit" }, [_c("i"), _vm._v(" 案件信息")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box-tit" }, [_c("i"), _vm._v(" 案件回顾")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box-tit" }, [_c("i"), _vm._v(" 案件详情")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "con-desc" }, [
      _vm._v(
        " 本文版权归原作者所有，内容仅代表作者本人观点，不代表法临平台的立场。如有任何疑问或需要删除请通过 "
      ),
      _c("a", [_vm._v("【客服中心】")]),
      _vm._v("联系我们。 ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }